module.exports = __webpack_public_path__ + "img/SAUDIA-2.4013889e.jpg";